/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown>, pct: NonNullable<unknown> }} Prescription_Reason_Goal_ActivationInputs */

const en_us2_prescription_reason_goal_activation = /** @type {(inputs: Prescription_Reason_Goal_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hits ${i?.muscle} hard: ${i?.pct}% activation`)
};

const pt_br2_prescription_reason_goal_activation = /** @type {(inputs: Prescription_Reason_Goal_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ativa bem o ${i?.muscle}: ${i?.pct}% de ativação`)
};

const es_419_prescription_reason_goal_activation = /** @type {(inputs: Prescription_Reason_Goal_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activa bien ${i?.muscle}: ${i?.pct}% de activación`)
};

const pt_pt2_prescription_reason_goal_activation = /** @type {(inputs: Prescription_Reason_Goal_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ativa bem o ${i?.muscle}: ${i?.pct}% de ativação`)
};

const fr_fr2_prescription_reason_goal_activation = /** @type {(inputs: Prescription_Reason_Goal_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sollicite fortement ${i?.muscle} : ${i?.pct} % d'activation`)
};

const de_de2_prescription_reason_goal_activation = /** @type {(inputs: Prescription_Reason_Goal_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trifft ${i?.muscle} stark: ${i?.pct}% Aktivierung`)
};

const it_it2_prescription_reason_goal_activation = /** @type {(inputs: Prescription_Reason_Goal_ActivationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attiva molto ${i?.muscle}: ${i?.pct}% di attivazione`)
};

/**
* | output |
* | --- |
* | "Hits {muscle} hard: {pct}% activation" |
*
* @param {Prescription_Reason_Goal_ActivationInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_goal_activation = /** @type {((inputs: Prescription_Reason_Goal_ActivationInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Goal_ActivationInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_goal_activation(inputs)
	if (locale === "es-419") return es_419_prescription_reason_goal_activation(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_goal_activation(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_goal_activation(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_goal_activation(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_goal_activation(inputs)
	return en_us2_prescription_reason_goal_activation(inputs)
});
export { prescription_reason_goal_activation as "prescription.reason.goal_activation" }